import { createContext, Dispatch, useContext } from "react";
import { FeedCurveMilestone } from "../../../Services/Agrisys_GqlDataCaller/FeedDataCalls/GQLCalls/getFeedCurvesCall";

/* eslint-disable */
export type ThisMilestone = {
  selectedMilestone: FeedCurveMilestone | undefined,
  selectedDay: number | undefined
}

export enum GraphTypes {
  feedCurveWithLabels = "feedCurveWithLabels",
  feedCurveWithInfoBoxes = "feedCurveWithInfoBoxes",
  feedCurveMiniature = "feedCurveMiniature"
}

export enum IFeedCurveContextEnum {
  graphType = "graphType",
  milestone = "milestone",
  component = "component",
  error = "error"
}
/* eslint-enable */

export type IFeedCurveContext = {
  graphType: GraphTypes;
  milestone: ThisMilestone;
  component: number | undefined;
  error: { Elementid: number, errorText: string };
};

export type FeedCurveDispatcherT = Deep_Partial<IFeedCurveContext>;

type FeedCurveContexter = {
  state: IFeedCurveContext,
  dispatch: Dispatch<FeedCurveDispatcherT>
}

export const FeedCurveContext = createContext<FeedCurveContexter | undefined>(undefined);

export function FeedCurveReducer(state: IFeedCurveContext, action: FeedCurveDispatcherT) {
  let ResultState = { ...state };
  Object.entries(action).forEach(([type, payload], index) => {
    switch (type) {
      case IFeedCurveContextEnum.graphType: ResultState = { 
        ...ResultState, 
        graphType: payload as GraphTypes 
      };
      break;
      case IFeedCurveContextEnum.milestone: ResultState = { ...ResultState, milestone: {
        selectedMilestone: (payload as ThisMilestone).selectedMilestone,
        selectedDay: (payload as ThisMilestone).selectedDay
      }};
        break;
        case IFeedCurveContextEnum.component: ResultState = { 
          ...ResultState, 
          component: payload as number 
        };
        break;
        case "error": ResultState = { ...ResultState, error: payload as IFeedCurveContext["error"] };
      break;
        default: console.error(`Unhandled action type: ${type}`)
      break
    }
  })
  return ResultState;
}

export const useFeedCurveContext = () => {
  const context = useContext(FeedCurveContext);
  if (!context) {
    throw new Error("useFeedCurveContext must be used within a ModalProvider");
  }
  return context;
};